import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from 'base/redux/configureStore';
import App from 'base/views/App';
import { unregister } from './registerServiceWorker';


ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root'));
unregister();



// WEBPACK FOOTER //
// ./src/index.js